import { call, put, select, takeLatest } from 'redux-saga/effects'
import { CadImportConstants } from '../store/cadImport.constants'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { ICadImportState } from '../store/cadImport.types'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { getCadImportSelector } from '../selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { onSelectPCR } from '../../home/store/home.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { buildPcrSummary } from '../../../utilities/pcr.util'

export function* saveCadImport() {
  const cadImport: ICadImportState = yield select(getCadImportSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const pcrDocUpdated = { ...pcrDoc, cadImport }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(onSelectPCR(buildPcrSummary(pcrDocUpdated)))
    } catch (e) {
      yield put(throwPcrException(`saveCadImport() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveCadImportSaga() {
  yield takeLatest([CadImportConstants.SET_SAVE_CAD_DATA_RESPONSE], performWithMutexHOG, saveCadImport)
}
